import { Pipe, PipeTransform } from '@angular/core';
import { User } from '@models/account/user.model';
import { first } from 'lodash';

@Pipe({
  name: 'userCorporation',
})
export class UserCorporationPipe implements PipeTransform {
  transform(user: User | null | undefined): string {
    if (user && user.communities) {
      if (user.communityId) {
        return (
          user.communities.find(x => x.id === user.communityId)?.corporation
            ?.name ?? ''
        );
      }
      return first(user.communities)?.corporation?.name ?? '';
    }
    return '';
  }
}
